import { Controller } from '@hotwired/stimulus'
import IMask from 'imask'
import { get } from '@rails/request.js'

export default class extends Controller {
  static targets = [
    'zipcode',
    'street',
    'streetNumber',
    'streetComplement',
    'neighborhood',
    'city',
    'state',
  ]

  connect() {
    this.zipcodeMask = IMask(this.zipcodeTarget, { mask: '00000-000' })
  }

  disconnect() {
    this.zipcodeMask?.destroy()
  }

  async zipcodeChanged() {
    const response = await get('/zipcode', {
      query: new URLSearchParams({ zipcode: this.zipcodeTarget.value }),
    })

    if (response.ok) {
      const json = await response.json

      this.streetTarget.value = json.street
      this.neighborhoodTarget.value = json.neighborhood
      this.cityTarget.value = json.city
      this.stateTarget.value = json.state
    }
  }
}
